// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import { createValidator } from "#stdnum-runtime";

const bic: GlobalValidator = createValidator("bic", 25);

export default bic;
export const compact = bic.compact;
export const format = bic.format;
export const validate = bic.validate;
export const generate = (): string =>
  bic.generate?.() ??
  (() => {
    throw new Error("Validator bic cannot generate values");
  })();
